<template>
  <div>
    <table-card
      style="margin-bottom: 24px"
      header="Customer information"
      :table-data="tableData"
      :table-model="tableModel1"
    />
    <table-card
      style="margin-bottom: 24px"
      header="Principal contacts"
      :table-data="tableData"
      :table-model="tableModel2"
    />
    <table-card
      style="margin-bottom: 24px"
      header="Payment Insight"
      :table-data="tableData"
      :table-model="tableModel3"
    />
    <table-card
      style="margin-bottom: 24px"
      header="Event Filings"
      :table-data="tableData"
      :table-model="tableModel4"
    />
    <table-card
      style="margin-bottom: 24px"
      header="Ownership Insights"
      :table-data="tableData"
      :table-model="tableModel5"
    />
    <table-card
      style="margin-bottom: 24px"
      header="Company Financials"
      :table-data="tableData"
      :table-model="tableModel6"
    />
    <table-card
      style="margin-bottom: 24px"
      header="Financial Strength Insight"
      :table-data="tableData"
      :table-model="tableModel7"
    />
  </div>
</template>

<script>
import TableCard from './table-card'
import { getGlobalReportDetail } from '../../../api'
import numeral from 'numeral'
import { mapGetters } from 'vuex'

export default {
  data() {
    const formatAmount = num => {
      return numeral(num).format('0,0.00')
    }
    const tableModel1 = [
      { label: 'Duns Number', key: 'dunsNumber' },
      {
        label: 'Currency',
        key: 'dbdufaultCurrency',
      },
      { label: 'Primary Name', key: 'primaryName' },
      { label: 'Trade Style Names', key: 'tradeStyleNames' },
      { label: 'Primary Address Street', key: 'primaryAddressStreet' },
      {
        label: 'Mailing Address Minor Town Name',
        key: 'mailingAddressMinorTownName',
      },
      { label: 'Primary Address Minor Town', key: 'primaryAddressMinorTown' },
      { label: 'Primary Address Region Name', key: 'primaryAddressRegionName' },
      { label: 'Primary Address County Name', key: 'primaryAddressCountyName' },
      {
        label: 'Organization Primary Address Postal Code',
        key: 'organizationPrimaryAddressPostalCode',
      },
      {
        label: 'ISO Alpha 2 Char Country Code',
        key: 'isoAlphaCharCountryCode',
      },
      { label: 'Telephone', key: 'telephone' },
      {
        label: 'Telephone Number International Dialing Code',
        key: 'telNumberInternationalDialingCode',
      },
      {
        label: 'Organization Identification Numbers',
        key: 'organizationIdentificationNumbers',
      },
      {
        label: 'Ownership Control Year',
        key: 'ownershipControlYear',
      },
      {
        label: 'Incorporation Year',
        key: 'incorporationYear',
      },
      {
        label: 'Operating Status Start Date',
        key: 'operatingStatusStartDate',
      },
      {
        label: 'Number of Employees Value',
        key: 'numberOfEmployeesValue',
      },
      {
        label: 'Primary Industry Code USSicV4 Code',
        key: 'primaryIndustryCodeUssicv4Code',
      },
      {
        label: 'Industry Code USSicV4 Text',
        key: 'industryCodeUssicv4Text',
      },
      {
        label: 'Business Legal Structure',
        key: 'businessLegalStructure',
      },
      {
        label: 'Activities Text',
        key: 'activitiesText',
      },
      {
        label: 'Operating Status Text',
        key: 'operatingStatusText',
      },
      {
        label: 'Banks',
        key: 'banks',
      },
      {
        label: 'Bank Name',
        key: 'bankName',
      },
      {
        label: 'Business Legal Structure Text',
        key: 'businessLegalStructureText',
      },
      {
        label: 'Ownership Control Type Text',
        key: 'ownershipControlTypeText',
      },
      {
        label: 'Is Small Business Indicator',
        key: 'isSmallBusinessIndicator',
      },
    ] // customer information
    const tableModel2 = [
      {
        label: 'Current Principal Full Name',
        key: 'currentPrincipalFullName',
      },
      {
        label: 'Current Principal Job Title',
        key: 'currentPrincipalJobTitle',
      },
    ] // principal contacts
    const tableModel3 = [
      {
        label: 'Business Trading Summary Paydex Score',
        key: 'businessTradingSummaryPaydexScore',
      },
      {
        label: 'Trade Norms Paydex Norms Lower Quartile',
        key: 'businessTradingSummaryPaydexScore',
      },
      {
        label: 'Trade Norms Paydex Norms Upper Quartile',
        key: 'tradeNormsPaydexNormsUpperQuartileScore',
      },
      {
        label: 'Business Trading Summary Total Experiences Count',
        key: 'businessTradingSummaryTotalExperiencesCount',
      },
      {
        label: 'Block Status Reason',
        key: 'blockStatusReason',
      },
      {
        label: 'Business Trading Summary Payment Behavior Days',
        key: 'businessTradingSummaryPaymentBehaviorDays',
      },
      {
        label: 'Business Trading Summary Payment Behavior Description',
        key: 'businessTradingSummaryPaymentBehaviorDescription',
      },
      {
        label: 'Slow Experiences Amount',
        key: 'slowExperiencesAmount',
      },
    ] // payment insight
    const tableModel4 = [
      {
        label: 'Financial Embarrassment Indicator',
        key: 'financialEmbarrassmentIndicator',
      },
      {
        label: 'Disaster Special Events Indicator',
        key: 'disasterSpecialEventsIndicator',
      },
      {
        label: 'Financial Events Indicator',
        key: 'financialEventsIndicator',
      },
      {
        label: 'Operational Special Events Indicator',
        key: 'operationalSpecialEventsIndicator',
      },
      {
        label: 'Significant Events Indicator',
        key: 'significantEventsIndicator',
      },
      {
        label: 'Open Suits Indicator',
        key: 'openSuitsIndicator',
      },
      {
        label: 'Claims Indicator',
        key: 'claimsIndicator',
      },
      {
        label: 'Open Secured Filings Indicator',
        key: 'openSecuredFilingsIndicator',
      },
    ] // event filings table
    const tableModel5 = [
      { label: 'Capital Amount Value', key: 'capitalAmountValue' },
      { label: 'Capital Details Type Text', key: 'capitalDetailsTypeText' },
      { label: 'Capital Amount Currency', key: 'capitalAmountCurrency' },
    ] // Ownership Insights
    const tableModel6 = [
      {
        label: 'Latest Financials Units',
        key: 'latestFinancialsUnits',
      },
      {
        label: 'Latest Financials Cash and Other Liquid Assets',
        key: 'latestFinancialsCashAndOtherLiquidAssets',
      },
      {
        label: 'Latest Financials Accounts Receivable',
        key: 'latestFinancialsAccountsReceivable',
      },
      {
        label: 'Latest Financials Accounts Payable',
        key: 'latestFinancialsAccountsPayable',
      },
      {
        label: 'Latest Financials Inventory',
        key: 'latestFinancialsInventory',
      },
      {
        label: 'Latest Financials Total Fixed Assets',
        key: 'latestFinancialsTotalFixedAssets',
      },
      {
        label: 'Latest Financials Total Current Assets',
        key: 'latestFinancialsTotalCurrentAssets',
      },
      {
        label: 'Latest Financials Total Current Liabilities',
        key: 'latestFinancialsTotalCurrentLiabilities',
      },
      {
        label: 'Latest Financials Total Assets Amount',
        key: 'latestFinancialsTotalAssetsAmount',
      },
      {
        label: 'Latest Financials Total Long Term Liabilities',
        key: 'latestFinancialsTotalLongTermLiabilities',
      },
      {
        label: 'Latest Financials Total Liabilities',
        key: 'latestFinancialsTotalLiabilities',
      },
      {
        label: 'Latest Financials Total Equity Amount',
        key: 'latestFinancialsTotalEquityAmount',
      },
      {
        label: 'Latest Financials Tangible Networth Amount',
        key: 'latestFinancialsTangibleNetworthAmount',
      },
      {
        label: 'Sales Revenue Amount',
        key: 'salesRevenueAmount',
      },
      {
        label: 'Latest Financials Net Income',
        key: 'latestFinancialsNetIncome',
      },
      {
        label: 'Latest Financial Statement From Date',
        key: 'latestFinancialStatementFromDate',
      },
      {
        label: 'Latest Financial Statement To Date',
        key: 'latestFinancialStatementToDate',
      },
      {
        label: 'Latest Financials Audit Qualified Indicator',
        key: 'latestFinancialsAuditQualifiedIndicator',
      },
    ] // company financials table
    const tableModel7 = [
      {
        label: 'D&B Assessment Standard Rating',
        key: 'dbassessmentStandardRating',
      },
      {
        label: 'D&B Assessment Delinquency Score National Percentile',
        key: 'dbassessmentDelinquencyScoreNationalPercentile',
      },
      {
        label: 'D&B Assessment Delinquency Score Class Score',
        key: 'dbassessmentDelinquencyScoreClassScore',
      },
      {
        label: 'D&B Assessment Failure Score Class Score',
        key: 'dbassessmentFailureScoreClassScore',
      },
      {
        label: 'D&B Assessment Delinquency Score Risk Incidence Percentage',
        key: 'dbassessmentDelinquencyScoreRiskIncidencePercentage',
      },
      {
        label: 'D&B Assessment Credit Limit Recommendation Maximum',
        key: 'dbassessmentCreditLimitRecommendationMaximum',
      },
      {
        label: 'D&B Assessment Failure Score Risk Incidence Percentage',
        key: 'dbassessmentFailureScoreRiskIncidencePercentage',
      },
      {
        label: 'D&B Assessment Delinquency Score Date',
        key: 'dbassessmentDelinquencyScoreDate',
      },
      {
        label: 'D&B Assessment Failure Score Class Score Text',
        key: 'dbassessmentFailureScoreClassScoreText',
      },
    ] // Financial Strength Insight
    return {
      tableData: {},
      tableModel1,
      tableModel2,
      tableModel3,
      formatAmount,
      tableModel4,
      tableModel5,
      tableModel6,
      tableModel7,
    }
  },
  computed: {
    ...mapGetters('app', ['bureauReportBasicInfo']),
  },
  mounted() {
    this._getGlobalReportDetail()
  },
  methods: {
    async _getGlobalReportDetail() {
      try {
        const { id } = this.bureauReportBasicInfo
        const { data } = await getGlobalReportDetail(id)
        this.tableData = data
        const filterCompanyFinancials = [
          'latestFinancialsCashAndOtherLiquidAssets',
          'latestFinancialsAccountsReceivable',
          'latestFinancialsAccountsPayable',
          'latestFinancialsTotalCurrentAssets',
          'latestFinancialsTotalCurrentLiabilities',
          'latestFinancialsTotalAssetsAmount',
          'latestFinancialsTotalLiabilities',
          'latestFinancialsTotalEquityAmount',
          'latestFinancialsTangibleNetworthAmount',
          'salesRevenueAmount',
          'latestFinancialsNetIncome',
        ]
        filterCompanyFinancials.forEach(key => {
          const value = this.tableData[key]
          this.tableData[key] = this.formatAmount(value)
        })
      } catch (err) {
        console.error(err)
      }
    },
  },
  components: {
    TableCard,
  },
}
</script>
